export var TLTeamEmployerRoutes = {
    "/team?brandId&member_id&brand_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.team",
        "reloadOnSearch": false,
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./tl-team-employer.module.js");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Team"
            }
        ],
        "views": {
            "body": {
                "component": "tlTeamEmployerComponent"
            }
        },
        "onEnter": ['$state', function ($state) {
            //Keep for sometime till we get to redirect to the new URL
            hRedirect($state.href('appLayout.schedule.core-hr.list', {source: 'TL'}));
        }]
    }
};
